export var getHasImages = function getHasImages(options) {
  return options.some(function (option) {
    return option.hasOwnProperty('imageUrl') || option.hasOwnProperty('imageSrcSet') && option.hasOwnProperty('imageSizes');
  });
};